export default __webpack_public_path__ + "static/media/b3.264a65a6.png";